import * as React from 'react';

import { ITagline, ProductLine } from '../../infrastructure/interfaces';
import Button from '../Button';
import {DropdownMenu} from '../DropdownMenu';
import { IDropdownMenuOption } from '../DropdownMenu/DropdownMenu';
import { Modal } from '../Modal';
import MarkdownTextArea from "../MarkdownTextArea"

export interface TaglineEditorProps {
  show: any;
  onClose: any;
  tagline?: ITagline;
  onSave(Tagline: ITagline): void;
}

export interface TaglineEditorState {
  editedTagline: ITagline;
  hasRequiredFields: boolean;
}

const placeholderTagline = {
  id: -1,
  title: "",
  productLine: ProductLine.SEED,
};

export default class TaglineEditorModal extends React.Component<TaglineEditorProps, TaglineEditorState> {

  constructor(props: TaglineEditorProps) {
    super(props);
    this.state = {
      editedTagline: (this.props.tagline) ? this.props.tagline : placeholderTagline,
      hasRequiredFields: (this.props.tagline) ? true : false
    };
  }

  componentWillReceiveProps(nextProps: TaglineEditorProps) {
    if (nextProps.tagline && (nextProps.tagline !== this.props.tagline)) {
      this.setState({editedTagline: nextProps.tagline }, () => this.hasValidFields());
    }
  }

  handleInputTitleChange(newTitle: string) {
    this.setState({
      editedTagline: {
        id: this.state.editedTagline.id,
        title: newTitle,
        productLine: this.state.editedTagline.productLine
      }
    }, () => this.hasValidFields());
  }

  handleInputProductLineChange(newProductLine: ProductLine) {
    this.setState({
      editedTagline: {
        id: this.state.editedTagline.id,
        title: this.state.editedTagline.title,
        productLine: newProductLine,
      }
    }, () => this.hasValidFields());
  }

  hasValidFields() {
    const hasValidText = (this.state.editedTagline.title.length > 1);
    this.setState({ hasRequiredFields: hasValidText });
  }

  closeModal() {
      this.setState({
        editedTagline: placeholderTagline,
      });
      this.props.onClose();
  }

  render() {
    var productLineOptionsList: IDropdownMenuOption[] = [{
        title:"Seed",
        onClick: () => {
          this.handleInputProductLineChange(ProductLine.SEED);
        }
      },
      {
        title:"Loveland",
        onClick: () => {
          this.handleInputProductLineChange(ProductLine.LOVELAND);
        }
      }
    ];

    return (
        <Modal show={this.props.show}
          onClose={() => {this.closeModal();}}
        >
            <Modal.Header>
                <Modal.Title>
                    <h5>
                        {this.props.tagline ? "Edit Tagline" : 'Create Tagline'}
                    </h5>
                </Modal.Title>
                <Button bsClass="close" onClick={() => {this.closeModal();}}></Button>
            </Modal.Header>
            <Modal.Body>
                <div className="editTaglineContainer">
                    <div className="editTaglineInputContainer">
                        <div>
                            <b>Text:  </b>
                        </div>
                        <div>
                            <MarkdownTextArea
                                textValue={this.state.editedTagline.title}
                                onChange={(text: string) => this.handleInputTitleChange(text)}
                            />
                        </div>
                    </div>
                    <div className="editTaglineInputContainer">
                        <div>
                            <b>Product Line:  </b>
                        </div>
                        <div>
                            <DropdownMenu
                                title={this.state.editedTagline.productLine == ProductLine.LOVELAND ? "Loveland" : "Seed"}
                                options={productLineOptionsList}
                                extraWide={true}
                            />
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button bsClass="cancel" onClick={() => {this.closeModal();}}>
                    Cancel
                </Button>
                <Button
                    bsClass="primary"
                    disabled={!this.state.hasRequiredFields}
                    onClick={() => {
                        this.props.onSave(this.state.editedTagline);
                        this.setState({
                          editedTagline: placeholderTagline,
                        });
                    }}
                >
                    Save Changes
                </Button>
            </Modal.Footer>
        </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/TaglineEditorModal.tsx